/*
 * Twenty 3 — variant auto-select
 * When a customer picks an option value that doesn't exist with the other
 * current selections (e.g. 5XL while "Regular" is selected, but 5XL only
 * comes in Tall), switch the other options to the closest combination that
 * exists, so the price and Add to Cart stay valid.
 */
(function () {
  if (window.__t3VariantAutoselect) return;
  window.__t3VariantAutoselect = true;

  var cache = {};

  function baseUrl(picker) {
    return ((picker && picker.dataset.productUrl) || '').split('?')[0];
  }

  function load(picker) {
    var url = baseUrl(picker);
    if (!url || cache[url]) return;
    var entry = (cache[url] = { data: null });
    fetch(url + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { entry.data = p; })
      .catch(function () {});
  }

  function preloadAll() {
    document.querySelectorAll('variant-picker[data-product-url]').forEach(load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preloadAll);
  } else {
    preloadAll();
  }

  ['pointerdown', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var picker = e.target instanceof Element ? e.target.closest('variant-picker') : null;
      if (picker) load(picker);
    }, true);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement) || t.dataset.variantId) return;

    var picker = t.closest('variant-picker');
    if (!picker) return;

    var entry = cache[baseUrl(picker)];
    var product = entry && entry.data;
    if (!product || !product.variants) return;

    var fi = parseInt(t.dataset.fieldsetIndex || '', 10);
    if (isNaN(fi)) return;

    var optionCount = (product.options || []).length;
    var current = [];
    for (var i = 0; i < optionCount; i++) {
      var checked = picker.querySelector('input[data-fieldset-index="' + i + '"]:checked');
      current[i] = checked ? checked.value : null;
    }
    current[fi] = t.value;

    var matches = product.variants.filter(function (v) { return v.options[fi] === t.value; });
    if (!matches.length) return;

    function score(v) {
      var s = v.available ? 100 : 0;
      v.options.forEach(function (o, idx) { if (o === current[idx]) s += 1; });
      return s;
    }
    matches.sort(function (a, b) { return score(b) - score(a); });
    var best = matches[0];

    best.options.forEach(function (val, idx) {
      if (idx === fi) return;
      var radios = picker.querySelectorAll('input[data-fieldset-index="' + idx + '"]');
      for (var j = 0; j < radios.length; j++) {
        var r = radios[j];
        if (r.value === val) {
          if (!r.checked) {
            if (typeof picker.updateSelectedOption === 'function') {
              picker.updateSelectedOption(r);
            } else {
              r.checked = true;
            }
          }
          break;
        }
      }
    });

    t.dataset.variantId = String(best.id);
  }, true);
})();
